import React, { useEffect, useState } from 'react';
import { TableStyle, TableSecStyle } from './styles';
import TableSort from '../../../components/TableSort';
import Spin from '../../../components/Spin';
import { ApplicationState } from '../../../store';
import { useSelector } from 'react-redux';
import mask from '../../../utils/mask';
import { Sorter } from '../../../utils/sorte';
import { SecondaryTableService, IResponse, IProps } from './services';
import { ColumnsType } from 'antd/lib/table';
import Swal from 'sweetalert2';

export const TableSec: React.FC<{ ordemCarga: number; codEmp: number }> = ({
  ordemCarga,
  codEmp,
}) => {
  const [response, setResponse] = useState<IResponse | undefined>(undefined);
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);

  useEffect(() => {
    let controller = new AbortController();

    try {
      SecondaryTableService.getPedidosOrdemCarga(ordemCarga, codEmp, parceiros).then((res) => {
        setResponse(res?.data);
      });
    } catch (error: any) {
      if (error.response.data.Error)
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.Error,
        });
      else
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Erro ao carregar os dados!',
        });

      setResponse({ total: 0, pedidos: {} as IProps });
    }
    return () => {
      controller.abort();
    };
  }, [codEmp, ordemCarga, parceiros]);

  const columns: ColumnsType<IProps> = [
    {
      title: 'N° da NF',
      dataIndex: 'numNota',
      key: 'numNota',
      width: 120,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 1,
      },
      render: (text) => {
        return text ? text : 'Não informado';
      },
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      key: 'fornecedor',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 2,
      },
      render: (text) => {
        return text ? mask('camelCase', text) : 'Não informado';
      },
    },
    {
      title: 'Destinatário',
      dataIndex: 'destinatario',
      key: 'destinatario',
      width: 300,
      sorter: {
        compare: Sorter.STRING,
        multiple: 3,
      },
      render: (text) => {
        return text ? mask('camelCase', text) : 'Não informado';
      },
    },
    {
      title: 'Cidade origem',
      dataIndex: 'cidadeOrigem',
      key: 'cidadeOrigem',
      width: 200,
      sorter: {
        compare: Sorter.STRING,
        multiple: 4,
      },
      render: (text) => {
        return text ? mask('camelCase', text) : 'Não informado';
      },
    },
    {
      title: 'Peso bruto',
      dataIndex: 'pesoBruto',
      key: 'pesoBruto',
      width: 150,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 5,
      },
      render: (text) => {
        return text ? mask('peso', text) : 'Não informado';
      },
    },
    {
      title: 'Valor da mercadoria',
      dataIndex: 'valor',
      key: 'valor',
      width: 200,
      sorter: {
        compare: Sorter.DEFAULT,
        multiple: 6,
      },
      render: (text) => {
        return text ? mask('currency', text) : 'Não informado';
      },
    },
    {
      title: 'Quantidade',
      dataIndex: 'qtdVolume',
      key: 'qtdVolume',
      width: 100,
      sorter: {
        compare: Sorter.STRING,
        multiple: 7,
      },
      render: (text) => {
        return text ? mask('quantidade', text) : 'Não informado';
      },
    },
    {
      title: 'Tipo de volume',
      dataIndex: 'tipoVolume',
      key: 'tipoVolume',
      width: 150,
      sorter: {
        compare: Sorter.STRING,
        multiple: 8,
      },
      render: (text) => {
        return text ? (text.length > 2 ? mask('camelCase', text) : text) : 'Não informado';
      },
    },
  ];

  return response ? (
    <TableStyle>
      {response?.total !== 0 ? (
        <TableSort
          pagination={false}
          columns={columns}
          scroll={{ x: 1520 }}
          size={'small'}
          loading={response === undefined}
          dataSource={response?.pedidos}
        />
      ) : (
        <div>
          <h2>Nenhum registro encontrado</h2>
        </div>
      )}
    </TableStyle>
  ) : (
    <TableSecStyle>
      <Spin color="#1d4354" />
    </TableSecStyle>
  );
};
